import React, { useEffect } from 'react';
import { Button, Col, Form, Modal, Row } from 'antd';
import { FormBox, InputBox } from '../../../../components/AntdAddons';
import { validations } from '../../../../config/validations/validations';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { AppDispatch } from '../../../../store/app';
import { useDispatch } from 'react-redux';
import { updateNumberManagement } from '../../../../store/NumberManagementSlice';

const LockState: React.FC<any> = (props) => {
  const { openUpdateModal, handleUpdateRequest, openUpdateData, getList } =
    props;

  const dispatch: AppDispatch = useDispatch();
  const [form] = Form.useForm();

  const lockState = [
    { label: 'True', value: 'true' },
    { label: 'False', value: 'false' },
  ];

  useEffect(() => {
    if (openUpdateData) {
      form.setFieldValue('phone_number', openUpdateData?.phone_number);
    }
  }, [openUpdateData, form]);

  const handleSubmit = (data) => {
    dispatch(updateNumberManagement(data))
      .then(() => {
        handleUpdateRequest();
        getList();
        form.resetFields();
      })
      .catch(() => {
        handleUpdateRequest();
        form.resetFields();
      });
  };
  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };

  return (
    <>
      <Modal
        open={openUpdateModal}
        destroyOnClose
        width={800}
        onCancel={handleUpdateRequest}
        closeIcon={<FontAwesomeIcon icon={faTimes} />}
        footer={false}
        className='addModal'
        title={`Lock State Request`}>
        <FormBox
          className='filterForm'
          form={form}
          onFinish={handleSubmit}
          onChange={handleChange}
          validateTrigger={['onBlur', 'onInput']}
          autoComplete='off'>
          <Row gutter={20} align={'top'}>
            <Col xs={24} md={12}>
              <InputBox.Text
                label='Phone Number'
                name={'phone_number'}
                disabled
                required
                rules={[validations.required.text('Phone Number')]}
              />
            </Col>
            <Col xs={24} md={12}>
              <InputBox.Select
                label='Lock State'
                name={'lock_state'}
                allowClear
                placeholder='Select Lock State'
                showSearch
                // initialValue={''}
                options={{
                  list: lockState && lockState,
                  valueKey: 'value',
                  textKey: 'label',
                }}
                rules={[validations.required.select('Lock State')]}
              />
            </Col>
            <Col xs={24} md={12}>
              <Button type='primary' htmlType='submit'>
                Submit
              </Button>
            </Col>
          </Row>
        </FormBox>
      </Modal>
    </>
  );
};

export default LockState;
